import LoginService from "..";

const fields = {
  username: 'loginName',
  password: 'userPassword',
}

export const account = new LoginService({
  url: '/api/user/v1/user/authLogin',
  fields,
});

export const adminAccount = new LoginService({
  url: '/api/user/v1/admin/authLogin',
  fields,
});